/**
 * @file 文档页页右侧锚点菜单
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useMemo} from 'react';
import {Menu} from 'antd';
import classNames from 'classnames';

import LinkA from '../../../../components/a/LinkA';
import {ITutorialsAnchorMenuItem} from '../../type';


const renderSubMenu = (
    menuList: ITutorialsAnchorMenuItem[],
    selectedKeysSet: Set<string>
) => (
    menuList.map(menuItem => {
        if ((menuItem.children?.length ?? 0) > 0) {
            return (
                <Menu.SubMenu
                    className={classNames({
                        'ant-menu-submenu-title-selected': selectedKeysSet.has(menuItem.key)
                    })}
                    key={menuItem.key}
                    title={
                        <LinkA to={menuItem.link || ''} title={menuItem.title}>
                            {menuItem.title}
                        </LinkA>
                    }
                >
                    {!!menuItem.children && renderSubMenu(menuItem.children, selectedKeysSet)}
                </Menu.SubMenu>
            );
        }
        return (
            <Menu.Item key={menuItem.key}>
                <LinkA to={menuItem.link || ''} title={menuItem.title}>
                    {menuItem.title}
                </LinkA>
            </Menu.Item>
        );
    })
);


export interface IDocRightMenuProps {
    openKeys: string[];
    selectedKeys: string[];
    menuList: ITutorialsAnchorMenuItem[];
}

const RightMenu: React.FC<IDocRightMenuProps> = props => {
    const {
        openKeys,
        selectedKeys,
        menuList
    } = props;

    const selectedKeysSet = useMemo(() => {
        return new Set(selectedKeys);
    }, [selectedKeys]);

    return (
        <Menu
            className="paddle-tutorials-right-menu"
            mode="inline"
            inlineIndent={14}
            openKeys={openKeys}
            selectedKeys={selectedKeys}
            expandIcon={<span />}
        >
            {renderSubMenu(menuList, selectedKeysSet)}
        </Menu>
    );
};

export default RightMenu;
